import { SpriteController } from "./sprite-controller.js";

let spriteController = new SpriteController(".product__keyframe");
window.sc = spriteController;

export { spriteController };
